import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Category } from '@/models/category.model';
import { ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { ref, computed, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryField',
  props: {
  label: {
    type: String,
  },
  modelValue: {
    type: Object as PropType<Category | undefined>,
    required: true,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  main: {
    type: Boolean,
    default: () => false,
  },
  sub: {
    type: Object as PropType<Category>,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore<ShiftCMSState & { cs: CategoriesState }>();
const emit = __emit;

const category = ref<Category | undefined>(props.modelValue);

function getParentString(c: Category, categories: Category[]): string {
  if (c.parentCategory) {
    const parent = categories.find((p) => p.id === c.parentCategory?.id);

    if (parent) {
      return `${getParentString(parent, categories)}${parent.title} - `;
    }
  }
  return '';
}

const parents = computed(() => [
  ...store.state.cs.categories.filter((v) =>
    props.sub ? v.parentCategory?.id === props.sub.id : false,
  ),
]);

const categoryItems = computed(() =>
  [...store.state.cs.categories]
    .sort((a, b) => a.index - b.index)
    .filter((v) => (props.main ? !v.parentCategory : true))
    .filter((v) =>
      props.sub
        ? (v.parentCategory &&
            [...parents.value.map((v) => v.id)].includes(
              v.parentCategory?.id,
            )) ||
          v.parentCategory?.id === props.sub.id
        : true,
    )
    .map((c) => {
      return {
        title: `${
          getParentString(c, store.state.cs.categories)
            ? `${getParentString(c, store.state.cs.categories)}`
            : ''
        }${c.title}`,
        value: c,
      };
    }),
);

function update(v: Category) {
  emit('update:modelValue', v);
  emit('change');
}

watch(
  () => props.modelValue,
  () => {
    category.value = props.modelValue;
  },
  { deep: true },
);

onMounted(() => {
  store.dispatch(CategoriesActions.GetCategories);
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_autocomplete, {
      label: props.label ? props.label : 'Category',
      modelValue: category.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event)),
        update
      ],
      items: categoryItems.value,
      chips: "",
      disabled: __props.disabled,
      multiple: false,
      valueComparator: (a, b) => a.id === b.id
    }, {
      item: _withCtx(({ props }) => [
        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["label", "modelValue", "items", "disabled", "valueComparator"]),
    _createVNode(_component_v_container, { style: {"padding-top":"0","padding-bottom":"0"} }, {
      default: _withCtx(() => [
        (!category.value && __props.required)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              type: "warning",
              density: "compact"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("This is required")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})